import type { FC } from 'react';

import logger from '@eneco/common/log';
import { useChat } from '@eneco/components/chat/useChat';
import { Button } from '@eneco/sparky';
import { useMediaQuery } from '@eneco/sparky/hooks';

export const ChatButton: FC<{
  buttonText: string | undefined;
  chatTopic: string | undefined;
}> = ({ buttonText, chatTopic }) => {
  const isMediumBreakpoint = useMediaQuery('md');

  try {
    const [mount] = useChat();

    return (
      <Button
        action="primary"
        size={isMediumBreakpoint ? 'regular' : 'compact'}
        tone="onLight"
        type="button"
        onClick={() => mount({ visibility: 'open', topic: chatTopic })}>
        {buttonText}
      </Button>
    );
    // Safeguard against accidental usage outside ChatProvider
  } catch (e) {
    logger.error('NtdDKV', e instanceof Error ? e.message : 'ChatButton could not render');
    return null;
  }
};
